import { createContext, useState } from "react";

const TransformContext = createContext({
  html: "",
  phrase: ""
});

export function TransformContextProvider(props) {

  const [html, setHtml ] = useState("")
  const [phrase, setPhrase] = useState("");
  const [showSyllables, setShowSyllables] = useState(false);
  const [showUnions, setShowUnions] = useState(false);
  const [showErres, setShowErres] = useState(false);
  const [showAproximantes, setShowAproximantes] = useState(false);
  const [showOclusivas, setShowOclusivas] = useState(false);
  const [showFricativas, setShowFricativas] = useState(false);
  const [showSonoras, setShowSonoras] = useState(false);
  const [showSinvoz, setShowSinvoz] = useState(false);
  
  function setHtmlHandler(html) {
    setHtml(html);
  }
  
  function setPhraseHandler(phrase) {
    setPhrase(phrase);
  }

  function setShowSyllablesHandler(value) {
    setShowSyllables(value);
  }

  function setShowUnionsHandler(value) {
    setShowUnions(value);
  }

  function setShowErresHandler(value) {
    setShowErres(value);
  }

  function setShowAproximantesHandler(value) {
    setShowAproximantes(value);
  }

  function setShowOclusivasHandler(value) {
    setShowOclusivas(value);
  }

  function setShowFricativasHandler(value) {
    setShowFricativas(value);
  }

  function setShowSonorasHandler(value) {
    setShowSonoras(value);
  }

  function setShowSinvozHandler(value) {
    setShowSinvoz(value);
  }

  const context = {
    phrase: phrase,
    html: html,
    showSyllables: showSyllables,
    showUnions: showUnions,
    showErres: showErres,
    showAproximantes: showAproximantes,
    showOclusivas: showOclusivas,
    showFricativas: showFricativas,
    showSonoras: showSonoras,
    showSinvoz: true,
    setHtml: setHtmlHandler,
    setPhrase: setPhraseHandler,
    setShowSyllables: setShowSyllablesHandler,
    setShowUnions: setShowUnionsHandler,
    setShowErres: setShowErresHandler,
    setShowAproximantes: setShowAproximantesHandler,
    setShowOclusivas: setShowOclusivasHandler,
    setShowFricativas: setShowFricativasHandler,
    setShowSonoras: setShowSonorasHandler,
    setShowSinvoz: setShowSinvozHandler
  };

  return (
    <TransformContext.Provider value={context}>
      {props.children}
      </TransformContext.Provider>
  );
}

export default TransformContext;


